import graphqlClient from "../../../apollo";

class CashAuditProvider {

    cashAuditExport(date) {
        return graphqlClient.query({
            query: require('./gql/CashAudit/cashAuditExport.graphql'),
            variables: {date},
            fetchPolicy: "network-only"
        })
    }
}

export default new CashAuditProvider()


